import React, {
  useState,
  useEffect,
  useCallback,
  // useRef,
  useMemo,
} from 'react';
import {
  // TextField,
  IconButton,
  Box,
  useTheme,
  Typography,
  FormControl,
  // InputLabel,
  Input,
  InputAdornment,
  // FormHelperText,
} from '@material-ui/core';
import dayjs from 'dayjs';
import SearchIcon from '@material-ui/icons/Search';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import { useIntl } from 'umi';
import DialogML from '@/components/DialogML';
import CloseIcon from '@material-ui/icons/Close';
import DataTableNativeML from '@/components/DataTableNativeML';
import ChooseCouponStyled from './ChooseCouponStyled';

export default (props) => {
  const {
    // handleSubmit,
    control,
    // errors,
  } = useForm({});
  // const tableRef = useRef();
  const intl = useIntl();
  const { formatMessage } = intl;

  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    setCoupons,
    dialogStatus,
    setDialogStatus,
    couponType,
    couponId,
    // allItemCoupons,
    setItemChooseCoupon = () => {},
    // editId,
    // coupons = [],
    setModify = () => {},
  } = props;

  const { data: cpList, total } =
    useSelector((state) => state.cpList?.cpList) || {};

  const itemCoupons =
    useSelector((state) => state.sceneMarketing?.coupons) || [];
  const couponsList = useSelector((state) => state.sceneMarketing?.couponsList);
  // 每次点击获得的每条信息的优惠券

  const labelCom = (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography variant="body1" className="coupon-dialog-title-style">
            {/* 选择优惠券 */}
            {formatMessage({ id: 'marketing.scene.holiday.d01.lbl02' })}
          </Typography>
        </Box>
        {dialogStatus && (
          <IconButton aria-label="close" onClick={() => onCloseDialog()}>
            <CloseIcon className="coupon-dialog-close-icon-style" />
          </IconButton>
        )}
      </Box>
    </Box>
  );

  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });

  const [title, setTitle] = useState();
  const [refreshTime, setRefreshTime] = useState();
  const [chooseCoupons, setChooseCoupons] = useState([]);
  const [storesChooseItemShowData, setStoresChooseItemShowData] = useState([]);
  const [storesChooseItemData, setStoresChooseItemData] = useState([]); //存储所有选中数据列
  const [chooseCouponIds, setChooseCouponIds] = useState([]);

  // 存数据
  const saveCouponData = () => {
    // chooseCoupons 需要传回
    // if (type === 'memberLevel'||type === 'allLevel') {
    // 全部等级
    let num = [];
    // console.log('chooseCoupons oldDat11', type, id);
    chooseCoupons.forEach((i) => {
      num.push(i.id);
      // 默认为1
      const obj = Array.isArray(itemCoupons)
        ? itemCoupons.find((item) => item.id === i.id)
        : null;
      if (obj) {
        i['couponCode'] = obj.couponCode;
      } else {
        i['couponCode'] = 1;
      }
      if (!i?.id) {
        i['id'] = i.couponId;
      }
    });
    // 暂时注释
    // setStoresChooseItemShowIdData(num);
    // setShowItemCouponData(chooseCoupons);
    setItemChooseCoupon(chooseCoupons);
    // setShowItemCouponData([...chooseCoupons,...itemCoupons]);
    setCoupons(chooseCoupons);
    dispatch({
      type: 'sceneMarketing/saveItemCoupons',
      payload: {
        value: {
          id: couponId,
          coupons: chooseCoupons,
        },
      },
    });
    setModify({});
    // 将新勾选的数组存储一下
    const newCouponList = [...chooseCoupons, ...itemCoupons];

    const newItemCoupon = newCouponList.filter((x, index) => {
      let newArray = [];
      newCouponList.forEach((item) => {
        newArray.push(item.id);
      });
      return newArray.indexOf(x.id) === index;
    });

    // console.log(newItemCoupon, 'newCouponList');
    const newArr = [...newItemCoupon];
    newArr.forEach((item) => {
      if (Array.isArray(item)) {
        item['couponCode'] = 1;
      }
    });
    dispatch({
      type: 'sceneMarketing/saveCouponsList',
      payload: {
        value: newItemCoupon,
      },
    });
  };

  const fetchCouponList = useCallback(() => {
    dispatch({
      type: 'cpList/getCpList',
      payload: {
        values: {
          title,
          status: 'NOT_COMPLETE',
          pageNum: pageData.pageNum,
          pageSize: pageData.pageSize,
        },
      },
    });
  }, [
    dispatch,
    pageData.pageNum,
    pageData.pageSize,
    refreshTime,
    dialogStatus,
  ]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  useMemo(() => {
    // 取数据，匹配数据
    if (itemCoupons) {
      let num = [];
      if (
        itemCoupons !== 'null' &&
        itemCoupons !== '[]' &&
        itemCoupons?.length > 0
      ) {
        // console.log(cpList, itemCoupons, 'newCoupon itemCoupons');
        const newCoupon = [];
        const selectCoupons = cpList
          ?.map((item) => {
            return itemCoupons
              ?.map((i) => {
                if (i.couponId === item.id) {
                  item['couponCode'] = i.couponCode;
                  return item;
                }
              })
              .filter(Boolean);
          })
          .filter((i) => i?.length > 0);
        // console.log(cpList, itemCoupons, 'newCoupon itemCoupons');
        selectCoupons &&
          selectCoupons.forEach((item) => {
            newCoupon.push(item[0]);
          });
        newCoupon &&
          newCoupon.forEach((i) => {
            num.push(i.id);
          });
        // setShowItemCouponData(newCoupon);
        // setStoresChooseItemShowIdData(num);
      } else {
        // console.log(itemCoupons, 'felix => itemCoupons list33');
        // setShowItemCouponData([]);
        // setStoresChooseItemShowIdData(num);

        setChooseCoupons([]);
      }
    }
  }, [couponType, couponId, cpList]);

  // 优惠券搜索
  const handleClickSearchStores = () => {
    setPageData({
      pageNum: 1,
      pageSize: pageData.pageSize,
    });
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    setRefreshTime(time);
  };

  // 优惠券列表分页
  const handleChangePage = (data) => {
    setPageData(data);
  };

  // 拿到优惠券的值进行匹配
  //  const allItemCoupons=useMemo(() => {
  //   // const arr=[];
  //   const arr=itemCoupons?.concat(chooseCoupons||[]);
  //   arr&&arr.forEach((item)=>{
  //     if (!item?.couponCode){
  //       item['couponCode']=1;
  //     }
  //   });
  //   return arr;
  // },[itemCoupons,chooseCoupons]);

  // console.log(allItemCoupons, 'allItemCoupons');

  // 优惠券列表过滤
  // const couponList = useMemo(() => {
  //   // cpList
  //   if (couponsList?.length > 0) {
  //     const chooseCoupon = [...couponsList];
  //     let newArr = cpList?.filter(
  //       (item) => !chooseCoupon?.some((ele) => ele.id === item.id),
  //     );
  //     return newArr;
  //   }
  //   return cpList;
  // }, [cpList, couponsList]);

  useMemo(() => {
    // setChooseCouponIds
    const ids = [];
    for (let i = 0; i < couponsList?.length; i++) {
      ids.push(couponsList[i].id);
    }

    setChooseCouponIds(ids);
  }, [couponsList]);

  // useMemo(() => {
  //   if (couponList?.length<1){
  //     setPageData({
  //       pageSize: 10,
  //       pageNum: pageData.pageNum+1,
  //     });
  //   }
  // }, [couponList]);

  const storesContent = () => {
    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '28px',
            marginBottom: '-18px',
          }}
        >
          <div className="coupon-input">
            <FormControl variant="standard">
              <Input
                id="standard-adornment-password"
                type="text"
                onChange={(e) => {
                  setTitle(e.target.value);
                  // storesNameRef.current = e.target.value;
                }}
                value={title}
                // placeholder="请输入优惠券名称"
                placeholder={formatMessage({
                  id: 'marketing.scene.holiday.d01.placeholder01',
                })}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => handleClickSearchStores()}
                      // handleClickSearchStores
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
        </div>
        <Box>
          <DataTableNativeML
            control={control}
            paging={true}
            columns={columns}
            columnKey="id"
            data={cpList}
            total={total}
            devicesMinWidth="auto"
            chooseIds={chooseCouponIds}
            page={{
              ...pageData,
            }}
            changePage={(data) => handleChangePage(data)}
            pagination={{
              ...pageData,
            }}
          />
        </Box>
      </>
    );
  };

  const columns = [
    {
      type: 'checkbox',
      width: '120',
      onChange: (a, b, c) => {
        const pageDataIdsSeries = cpList.map((item) => item.id); //当前分页的id数组
        const prevChooseItemData = c.filter((item) => {
          //过滤掉当前页的选中列
          return pageDataIdsSeries.indexOf(item.id) === -1;
        });
        let chooseDatasSeries = cpList.filter((fItem) => {
          //当前选中的数据过滤出当前页的数据
          return a.includes(fItem.id);
        });
        const newListData = [...prevChooseItemData, ...chooseDatasSeries];
        setChooseCoupons(newListData);
        return;
      },
    },
    {
      // title: '优惠券名称',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl03' }),
      align: 'center',
      id: 'title',
      key: 'title',
      width: 120,
    },
    {
      // title: '适用商品',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl04' }),
      id: 'isAllGoods',
      width: 100,
      align: 'center',
      key: 'isAllGoods',
      render: ({ isAllGoods }) => {
        switch (isAllGoods) {
          case 0:
            return '指定适用商品';
          case 1:
            return '所有商品';
          case 2:
            return '不适用商品';
          default:
            return '';
        }
      },
    },
    {
      // title: '优惠内容',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl05' }),
      align: 'center',
      id: 'subTitle',
      key: 'subTitle',
      width: 95,
    },
    {
      // title: '领取人限制',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl06' }),
      align: 'center',
      id: 'memberLimit',
      key: 'memberLimit',
      width: 115,
      render: ({ memberLimit }) => {
        return <div>{memberLimit ? '不限' : '会员'}</div>;
      },
    },
    {
      // title: '限领次数',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl07' }),
      align: 'center',
      id: 'isLimitMaxCoupons',
      key: 'isLimitMaxCoupons',
      width: 95,
      render: ({ isLimitMaxCoupons }) => {
        return <div>{!isLimitMaxCoupons ? '不限' : '限制'}</div>;
      },
    },
    {
      // title: '剩余库存',
      title: formatMessage({ id: 'marketing.scene.holiday.d01.lbl08' }),
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      width: 95,
    },
  ];

  // 关闭选择优惠券弹窗
  const onCloseDialog = (data) => {
    if (data) {
      // 存储输入框里的值
      setStoresChooseItemShowData(storesChooseItemData);
      saveCouponData();
      // showChooseData(couponType, couponId);
      // test
      // setChooseCoupons([])
      setChooseCoupons(chooseCoupons);
    } else {
      setStoresChooseItemData(storesChooseItemShowData);
      // setDialogStatus(false);
      setChooseCoupons(chooseCoupons);
    }
    setDialogStatus(false);
  };

  return (
    <ChooseCouponStyled theme={theme}>
      <DialogML
        open={dialogStatus}
        title={labelCom}
        minheightinit={480}
        minwidthinit={950}
        describe={storesContent()}
        // describe={<></>}
        handleClose={onCloseDialog}
        specilaAlgorithmLabValue={'ok'}
      />
    </ChooseCouponStyled>
  );
};
